import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

const Actions = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing(2)}px;
`;

const FormActions = ({ primaryAction, secondaryAction, children }) => {
  const defaultButtonProps = {
    variant: 'outlined',
    type: 'button',
    color: 'default',
    disabled: false,
    fullWidth: false,
    size: 'medium',
  };

  return (
    <Actions>
      {primaryAction && (
        <Button {...{ ...defaultButtonProps, ...primaryAction }}>{primaryAction.label}</Button>
      )}
      {secondaryAction && (
        <Button {...{ ...defaultButtonProps, ...secondaryAction }}>{secondaryAction.label}</Button>
      )}
      {children}
    </Actions>
  );
};

FormActions.propTypes = {
  primaryAction: PropTypes.object,
  secondaryAction: PropTypes.object,
  children: PropTypes.node,
};

FormActions.defaultProps = {
  primaryAction: null,
  secondaryAction: null,
  children: undefined,
};

export default FormActions;
